import React from 'react'
import { EXHIBITOR } from '../constants/staticText'
import { formatDayRange } from '../../eventsPublic/functions/formatDays'
import JobsTable from './JobsTable'

// Abschnitte der Aussteller-Profilseite (#239). Jeder Abschnitt traegt seine
// Ueberschrift als Namen (aria-labelledby) und entfaellt, wenn er leer waere.
const Abschnitt = ({ id, titel, children }) => (
    <section className="exhibitor-profile-section" aria-labelledby={id}>
        <h2 id={id}>{titel}</h2>
        {children}
    </section>
)

const berufName = (beruf) => (beruf.specialization ? `${beruf.title} ${beruf.specialization}` : beruf.title)

export const Messen = ({ events }) => events.length > 0 && (
    <Abschnitt id="profil-messen" titel={EXHIBITOR.events}>
        <ul className="exhibitor-profile-events">
            {events.map(ev => (
                <li key={ev.slug}>
                    <a href={`/events/${ev.slug}/`}>{ev.name}</a>
                    <span className="exhibitor-profile-days">{formatDayRange(ev.days)}</span>
                </li>
            ))}
        </ul>
    </Abschnitt>
)

const GRUPPEN = [...EXHIBITOR.professionGroups, { type: null, title: EXHIBITOR.otherProfessions }]
const artDerGruppe = (beruf) => (GRUPPEN.some(g => g.type === beruf.type) ? beruf.type : null)

const BerufListe = ({ berufe }) => (
    <ul className="exhibitor-profile-professions">
        {berufe.map(beruf => <li key={beruf.id}>{berufName(beruf)}</li>)}
    </ul>
)

// Berufe nach Art. Zwischenueberschriften nur, wenn es mehr als eine Gruppe
// gibt — sonst sagt die Abschnittsueberschrift schon alles (#245).
export const Berufe = ({ professions }) => {
    const gruppen = GRUPPEN
        .map(({ type, title }) => ({ title, berufe: professions.filter(p => artDerGruppe(p) === type) }))
        .filter(gruppe => gruppe.berufe.length > 0)
    if (0 === gruppen.length) return null

    return (
        <Abschnitt id="profil-berufe" titel={EXHIBITOR.professions}>
            {1 === gruppen.length
                ? <BerufListe berufe={gruppen[0].berufe} />
                : gruppen.map(({ title, berufe }) => (
                    <div key={title} className="exhibitor-profile-group">
                        <h3>{title}</h3>
                        <BerufListe berufe={berufe} />
                    </div>
                ))}
        </Abschnitt>
    )
}

export const Praktika = ({ internship, praktika }) => (internship || praktika.length > 0) && (
    <Abschnitt id="profil-praktika" titel={EXHIBITOR.internships}>
        {internship && <p>{EXHIBITOR.internshipsIntro}</p>}
        {praktika.length > 0 && (
            <BerufListe berufe={praktika} />
        )}
    </Abschnitt>
)

export const Stellen = ({ jobs, company }) => jobs.length > 0 && (
    <Abschnitt id="profil-stellen" titel={EXHIBITOR.jobs}>
        <JobsTable jobs={jobs.map(job => ({ ...job, company }))} />
    </Abschnitt>
)

export const Kontakt = ({ address, contact }) => (address || contact) && (
    <Abschnitt id="profil-kontakt" titel={EXHIBITOR.contact}>
        {address && <p>{address}</p>}
        {contact && <p>{contact}</p>}
    </Abschnitt>
)
